export type FileKind =
  | 'archive'
  | 'audio'
  | 'document'
  | 'image'
  | 'other'
  | 'pdf'
  | 'spreadsheet'
  | 'video';

const ARCHIVE_MIME_TYPES = new Set([
  'application/zip',
  'application/x-zip-compressed',
  'application/x-rar-compressed',
  'application/x-7z-compressed',
  'application/x-tar',
  'application/gzip',
]);

const SPREADSHEET_MIME_TYPES = new Set([
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'text/csv',
]);

const DOCUMENT_MIME_TYPES = new Set([
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'text/plain',
  'text/rtf',
]);

export const getFileKind = (mimeType: string): FileKind => {
  if (mimeType === 'application/pdf') {
    return 'pdf';
  }
  if (mimeType.startsWith('image/')) {
    return 'image';
  }
  if (mimeType.startsWith('video/')) {
    return 'video';
  }
  if (mimeType.startsWith('audio/')) {
    return 'audio';
  }
  if (ARCHIVE_MIME_TYPES.has(mimeType)) {
    return 'archive';
  }
  if (SPREADSHEET_MIME_TYPES.has(mimeType)) {
    return 'spreadsheet';
  }
  if (DOCUMENT_MIME_TYPES.has(mimeType)) {
    return 'document';
  }
  return 'other';
};
